// extracted by mini-css-extract-plugin
export default {"saveBtn":"PlayInfo_saveBtn__f34B5","disabled":"PlayInfo_disabled__Wn9gX"};